<template>
  <div>
    <!-- BEGIN: Modal Toggle -->
    <ModalLayout v-model="openResetModal" headerTitle="สร้างรหัสผ่านใหม่" @click:save="saveForm" :isDone="isDone" @click:cancel="clearModal" id="reset-password-modal" isMediumSize>
        <div class="grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
                <h3 class="font-medium text-base mr-auto font-bold text-theme-20">
                บัญชีผู้ใช้งาน
                </h3>
            </div>
            <div class="col-span-12">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="reset-username" class="form-label text-theme-98 sm:w-20">ชื่อผู้ใช้งาน <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <input
                            id="reset-username"
                            type="text"
                            class="form-control"
                            placeholder="กรุณากรอกชื่อผู้ใช้งาน"
                            data-test="reset-username"
                            disabled
                            v-model="passwordForm.username"
                        >
                    </div>
                </div>
            </div>
            <div class="col-span-12">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="reset-pw" class="form-label text-theme-98 sm:w-20">รหัสผ่าน <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <div class="flex">
                            <input
                                id="reset-pw"
                                :type="showPassword ? 'text': 'password'"
                                class="form-control"
                                placeholder="กรุณากรอกรหัสผ่าน"
                                data-test="reset-pw"
                                v-model="validate.password.$model"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.password.$error}"
                                @input="checkSameAsPassword"
                            >
                            <button class="btn btn-secondary ml-1" style="padding-top: 10px;padding-bottom: 10px;" @click="showPassword = !showPassword">
                                <EyeOffIcon class="w-4 h-4" v-if="!showPassword"/>
                                <EyeIcon class="w-4 h-4" v-else/>
                            </button>
                        </div>
                        <template v-if="validate.password.$error">
                            <div
                                v-for="(error, index) in validate.password.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-12">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="reset-cf-pw" class="form-label text-theme-98 sm:w-20">ยืนยันรหัสผ่าน <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <div class="flex">
                            <input
                                id="reset-cf-pw"
                                :type="showConfirmPassword ? 'text' : 'password'"
                                class="form-control"
                                placeholder="กรุณากรอกยืนยันรหัสผ่าน"
                                data-test="reset-cf-pw"
                                v-model="validate.confirm_password.$model"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.confirm_password.$error || isNotSameAsPassword}"
                                :state="isNotSameAsPassword"
                                @input="checkSameAsPassword"
                            >
                            <button class="btn btn-secondary ml-1" style="padding-top: 10px;padding-bottom: 10px;" @click="showConfirmPassword = !showConfirmPassword">
                                <EyeOffIcon class="w-4 h-4" v-if="!showConfirmPassword"/>
                                <EyeIcon class="w-4 h-4" v-else/>
                            </button>
                        </div>
                        <template v-if="validate.confirm_password.$error">
                            <div
                                v-for="(error, index) in validate.confirm_password.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                        <template v-if="isNotSameAsPassword">
                            <div
                                class="text-theme-24 mt-1 text-xs"
                            >
                                ยืนยันรหัสผ่านไม่ตรงกัน
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </ModalLayout>
  </div>
</template>
<script setup>
import { ref, watch, toRefs, reactive, onMounted } from 'vue'
import ModalLayout from "@/components/base/custom-modal/CustomModalLayout.vue"
import useVuelidate from '@vuelidate/core'
import { required, helpers, minLength } from '@vuelidate/validators'
import Swal from "sweetalert2"
import axios from 'axios';
import { useStore } from 'vuex';
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

const store = useStore()
const emit = defineEmits(["closeModal"])
const props = defineProps({
    resetStateData: Object
})
const cancelData = ref(false)
const openResetModal = ref(false)
const passwordForm = reactive({
    username: null,
    userId: null,
    password: null,
    confirm_password: null
})
const isDone = ref(false)
const isNotSameAsPassword = ref(null)
const showPassword = ref(false)
const showConfirmPassword = ref(false)

function cancelModalForm(){
    cancelData.value = true
    openResetModal.value = false
}
function openModal(){
    openResetModal.value = true
    cancelData.value = false
}
const rules = {
    password:{
        required: helpers.withMessage(`กรุณากรอกรหัสผ่าน`, required),
        minLength: helpers.withMessage(`รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร`,minLength(6)),
    },
    confirm_password:{
        required: helpers.withMessage(`กรุณากรอกยืนยันรหัสผ่าน`, required),
        minLength: helpers.withMessage(`รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร`,minLength(6)),
    }
}
const validate = useVuelidate(rules, toRefs(passwordForm), { $scope: false })
const saveForm = () =>{
    validate.value.$touch()
    if(validate.value.$invalid || isNotSameAsPassword.value){
        return ;
    }
    try{
        swalCustom.fire({
            text:"ยืนยันบันทึกข้อมูล",
            icon:"info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
        }).then(async (result)=>{
            if (result.isConfirmed) {
                const token = store.getters["userAuth/getToken"];
                const headers = {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": `application/json; charset=utf-8`,
                };
                const res = await axios.put(`${process.env.VUE_APP_BASE_API}kcadmin/users/${passwordForm.userId} `,
                    {
                        credentials: [{"temporary": false, "type": "password", "value": passwordForm.password}]
                    },
                    { headers }
                )
                .catch(()=>
                    swalCustom.fire({
                        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                        icon: "warning",
                        // timer: 3000, //timeOut for auto-close
                        confirmButtonText: "ปิด",
                    })
                )
                if (res.status === 200) {
                    swalCustom.fire({
                        text:"สำเร็จ",
                        icon: 'success',
                        timer: 3000,
                        confirmButtonText: "ปิด",
                    }).then(function () {
                        clearModal()
                    });
                }

            }
        })
    }
    catch(err){
        console.log("Error! ",err);
        swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            // timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
        });
    }
}
function clearModal(isUpdate=null){
    passwordForm.password = null
    passwordForm.confirm_password = null
    isNotSameAsPassword.value = null
    passwordForm.username = null
    passwordForm.userId = null
    showPassword.value = false
    showConfirmPassword.value = false
    isDone.value = false
    validate.value.$reset()
    openResetModal.value = false
    emit("closeModal",isUpdate)
}
watch(()=>props.resetStateData,(val)=>{
    if(val){
        passwordForm.username = val.username
        passwordForm.userId = val.id
        openResetModal.value = true
    }
})
function checkSameAsPassword(){
    if((!validate.value.password.required.$invalid || validate.value.password.$error) && !validate.value.confirm_password.required.$invalid){
        if(passwordForm.password !== passwordForm.confirm_password)
            isNotSameAsPassword.value = true
        else
            isNotSameAsPassword.value = false
    }
    else{
        isNotSameAsPassword.value = null
    }
}

</script>
<style lang="scss">

</style>

